import React from 'react';
import './App.css';
import {Router} from '@reach/router'
import Info from './pages/info';
import Share from './pages/share';

function App() {

  return (
    <div className="App">
      <Router>
        <Info path='/' />
        <Share path="/share" />
      </Router>
    </div>
  );
}

export default App;
